import type {FaqSlice} from 'prismicio-types'
import {memo} from 'react'
import type {Context} from 'src/common/types'
import DefaultFaq from './DefaultVariation'
import FaqV2 from './FaqV2Variation'

const Faq = (props: {slice: FaqSlice; context: Context}) =>
  props.slice.variation === 'v2' ? (
    <FaqV2 slice={props.slice} pageUid={props.context.pageUid} />
  ) : (
    <DefaultFaq slice={props.slice} />
  )

export default memo(Faq)
